import { Injectable, inject } from '@angular/core';

import { ModalGestureHelperService } from './modal-gesture-helper.service';
import { CLOSING_RATIO_HORIZONTAL, CLOSING_RATIO_VERTICAL, CLOSING_VELOCITY_HORIZONTAL, CLOSING_VELOCITY_VERTICAL } from './modal-gesture.constants';

@Injectable()
export class ModalGestureIsClosingService {
    readonly #modalGestureHelper = inject(ModalGestureHelperService);

    isModalClosingHorizontal(currentPosition: number, velocity: number): boolean {
        return this.isModalClosing(currentPosition, velocity, 'horizontal');
    }

    isModalClosingVertical(currentPosition: number, velocity: number): boolean {
        return this.isModalClosing(currentPosition, velocity, 'vertical');
    }

    private isModalClosing(currentPosition: number, velocity: number, dimension: 'horizontal' | 'vertical'): boolean {
        const { ratio, threshold } = this.getDimensionConfig(dimension);

        const closingVelocity = dimension === 'horizontal' ? CLOSING_VELOCITY_HORIZONTAL : CLOSING_VELOCITY_VERTICAL;

        const isOverClosingVelocity = velocity >= closingVelocity;
        const isOverClosingThreshold = currentPosition > threshold * ratio;

        return isOverClosingVelocity || isOverClosingThreshold;
    }

    private getDimensionConfig(dimension: 'horizontal' | 'vertical'): { ratio: number; threshold: number } {
        const { ratio, threshold } =
            dimension === 'horizontal'
                ? { ratio: CLOSING_RATIO_HORIZONTAL, threshold: this.#modalGestureHelper.viewportWidth }
                : { ratio: CLOSING_RATIO_VERTICAL, threshold: this.#modalGestureHelper.viewportHeight };

        return { ratio, threshold };
    }
}
